<template>
  <div class="kebab" @click="toggleMenu">
    <figure></figure>
    <figure class="middle" :class="{ 'active': isActive }"></figure>
    <p class="cross" :class="{ 'active': isActive }">x</p>
    <figure></figure>
    <ul class="dropdown" :class="{ 'active': isActive }">
      <slot name="buttons"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'KebabMenu',
  data () {
    return {
      isActive: false,
    }
  },
  methods: {
    toggleMenu () {
      this.isActive = !this.isActive
    },
  },
}
</script>

<style scoped lang="scss">
  $cubic-out: cubic-bezier(0.32, 2.04, 0.85, 0.54);
  $cubic-in: cubic-bezier(0.72, 1.2, 0.71, 0.72);

  $cyan: rgb(108, 127, 238);
  $grey: #9e9e9e;

  $shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 2px 8px 0 rgba(0, 0, 0, 0.12);

  .kebab {
    cursor: pointer;
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    padding: 0 16px;
    right: -16px;

    figure {
      width: 6px;
      height: 6px;
      border-radius: 5px;
      background: $cyan;
      margin: 3px 0;
    }
  }

  .middle {
    transition: all 0.25s $cubic-in;
    transform: scale(1);
    position: relative;
    box-shadow: 0 0.1px 0.1px 0 rgba(0, 0, 0, 0.16), 0 0.1px 0.3px 0 rgba(0, 0, 0, 0.12);
    -webkit-filter: blur(0.1px);
    filter: blur(0.1px);
  }

  .middle.active {
    transform: scale(4.5);
    transition: all 0.25s $cubic-out;
    box-shadow: 0 0.1px 0.1px 0 rgba(0, 0, 0, 0.16), 0 0.1px 0.3px 0 rgba(0, 0, 0, 0.12);
  }

  .cross {
    position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    margin-top: -1px;
    font-family: inherit;
    color: white;
    transition: all 0.2s $cubic-in;
    font-size: 20px;
    user-select: none;
  }

  .cross.active {
    transform: translate(-50%, -50%) scale(1);
    transition: all 0.15s $cubic-out;
  }

  .dropdown {
    position: absolute;
    right: 0;
    top: 3em;
    transition: all 0.25s ease-out;
    transform: scale(0);
    transform-origin: 100% 0;
    box-shadow: $shadow;

    li {
      display: block;
      width: 100%;

      a {
        width: 100%;
        padding: 1em 18px;
        display: inline-block;
        white-space: pre;
        box-sizing: border-box;

        &:hover {
          background: lighten($grey, 30%);
        }
      }
    }

    &:hover {
      ul {
        transform: scale(1);
      }
    }
  }

  .dropdown.active {
    transform: scale(1);
    transition: all 0.25s cubic-bezier(0.5, 1.8, 0.9, 0.8);
    background-color: #ffffff;
    z-index: 999;
  }
</style>
